<template>
  <div class="cardBox">
    <div class="card">
      <div class="content">
        <div class="back">
          <div class="back-content">
            <svg stroke="#ffffff" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1024 1024" height="50px" width="50px" fill="#ffffff">
              <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
              <g stroke-linejoin="round" stroke-linecap="round" id="SVGRepo_tracerCarrier"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M771.411405 194.986179l-25.599936 45.653219 79.359801-15.359961S853.3312 170.66624 771.411405 194.986179zM554.66528 387.83903l66.133168-20.479948 10.239974-35.413245-71.253155 25.17327z m30.719923-106.6664l65.706503-15.359961 10.239974-42.66656-66.133168 15.359961z m121.599696 66.133168l81.066464-20.479948 20.479949-50.773207-85.33312 25.599936zM273.919315 575.571894l81.49313-30.719923 4.693321-65.706502-70.826489 35.413245z m127.99968-355.412444l-42.66656 15.359961-8.959977 55.893194 40.533232-10.239975zM309.33256 426.6656l61.013181-20.479949 10.239974-55.466528-55.893193 14.933296zM853.3312 0H170.66624a170.66624 170.66624 0 0 0-170.66624 170.66624v682.66496-157.012941l213.3328-95.573094 60.586515-334.932496-85.33312 40.533232 20.479949-127.99968a2773.3264 2773.3264 0 0 1 298.66592-45.653219l-70.82649 383.99904a3469.644659 3469.644659 0 0 1 506.878733-154.452948l-15.359961 61.013181a1559.462768 1559.462768 0 0 0-314.452548 136.959658l10.239975 15.359961s187.732864-101.546413 207.786147 25.173271c0 0 25.599936 55.893194-40.533232 131.83967A944.637638 944.637638 0 0 1 436.478909 938.66432c0-2.559994 5.119987-48.213213 5.119987-48.213213s207.786147-91.306438 263.679341-218.026121c0 0 25.599936-96.426426-101.546413-40.533232a222.292778 222.292778 0 0 0-70.82649 60.586515l-50.773206-20.053283a413.438966 413.438966 0 0 1 29.866592-81.919796l-101.119747 46.079885L365.225754 895.99776l-55.893194 20.479949 25.599936-238.506071S99.413085 801.704662 0 870.82449A170.66624 170.66624 0 0 0 170.66624 1023.99744h682.66496a170.66624 170.66624 0 0 0 170.66624-170.66624V170.66624a170.66624 170.66624 0 0 0-170.66624-170.66624z m24.319939 235.519411l-60.586515 136.959658-350.292458 106.6664s55.893194-341.33248 66.133168-350.292458l111.359722-10.239974-14.933296 35.83991 55.893194-15.359961 35.413244-96.426426h121.599696l-35.413244 75.946477s116.906374-14.933296 70.826489 116.906374z">
                </path>
              </g>
            </svg>
            <strong>智联已支持</strong>
          </div>
        </div>
        <div class="front">
          <div class="img">
            <div class="circle">
            </div>
            <div class="circle" id="right">
            </div>
            <div class="circle" id="bottom">
            </div>
          </div>
          <div class="front-content">
            <div class="title">智联功能一览</div>
            <div class="desc">
              <div>职位自动刷新</div>
              <div>自动保存简历</div>
              <div>人选简历查重</div>
              <div>一键自动复聊</div>
              <div><span style="color: #3b82f6; font-weight: bold;">AI</span>精准打招呼</div>
              <div><span style="color: #3b82f6; font-weight: bold;">AI</span>自动回复</div>
            </div>
            <div class="btn">
              <el-button @click="handGreet" size="small" plain round>立即使用</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handGreet() {
      this.$router.push({
        path: '/zlgreet'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.card {
  overflow: visible;
  width: 240px;
  height: 299px;
  box-sizing: border-box;
  user-select: none;

  .content {
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: transform 300ms;
    box-shadow: 0px 0px 10px 1px #252d3a;
    border-radius: 5px;

    .front,
    .back {
      background-color: #252d3a;
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
      border-radius: 5px;
      overflow: hidden;
    }

    .back {
      width: 100%;
      height: 100%;
      justify-content: center;
      display: flex;
      align-items: center;
      overflow: hidden;
    }

    .back::before {
      position: absolute;
      content: ' ';
      display: block;
      width: 160px;
      height: 160%;
      background: linear-gradient(90deg, transparent, #45A2FF, #45A2FF, #45A2FF, #45A2FF, transparent);
      animation: rotation_481 5000ms infinite linear;
    }

    .back-content {
      position: absolute;
      width: 99%;
      height: 99%;
      background-color: #1e2834;
      border-radius: 5px;
      color: white;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 30px;
    }

    .front {
      transform: rotateY(180deg);
      color: white;

      .img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;

        .circle {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background-color: #ffbb66;
          position: relative;
          filter: blur(15px);
          animation: floating 2600ms infinite linear;
        }

        #bottom {
          background-color: #ff8866;
          left: 50px;
          top: 0px;
          width: 150px;
          height: 150px;
          animation-delay: -800ms;
        }

        #right {
          background-color: #ff2233;
          left: 160px;
          top: -80px;
          width: 30px;
          height: 30px;
          animation-delay: -1800ms;
        }
      }

      .front-content {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 10px;

        .title {
          letter-spacing: 2px;
          background-color: #00000055;
          font-size: 14px;
          padding: 5px 10px;
          border-radius: 10px;
          backdrop-filter: blur(2px);
          width: fit-content;
        }

        .desc {
          letter-spacing: 2px;
          margin-top: 10px;
          padding: 10px;
          border-radius: 10px;
          background-color: #00000055;
          font-size: 14px;
          line-height: 2.1;
        }

        .btn {
          margin-top: 10px;
          text-align: center;
          cursor: pointer;

          .button {
            width: fit-content;
            display: flex;
            padding: 10px;
            cursor: pointer;
            font-weight: bold;
            border-radius: 30px;
            text-shadow: 2px 2px 3px rgb(136 0 136 / 50%);
            background: linear-gradient(15deg, #880088, #aa2068, #cc3f47, #de6f3d, #f09f33, #de6f3d, #cc3f47, #aa2068, #880088) no-repeat;
            background-size: 300%;
            color: #fff;
            border: none;
            background-position: left center;
            box-shadow: 0 30px 10px -20px rgba(0, 0, 0, .2);
            transition: background .3s ease;
          }

          .button:hover {
            background-size: 320%;
            background-position: right center;
          }
        }
      }
    }
  }
}

.card:hover .content {
  transform: rotateY(180deg);
}


@keyframes rotation_481 {
  0% {
    transform: rotateZ(0deg);
  }

  0% {
    transform: rotateZ(360deg);
  }
}

@keyframes floating {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(0px);
  }
}
</style>